module.exports = __webpack_public_path__ + "fa-regular-400.eot?701ae6abd4719e9c2ada3535a497b341";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fa-regular-400.eot
// module id = 10
// module chunks = 0